import { Component } from '@angular/core';
@Component({
  selector: 'app-admin-dashboard',
  template: `
    <h2>Admin Dashboard</h2>
    <mat-card>
      <p>Admin-only controls go here (user management, system stats).</p>
    </mat-card>
  `
})
export class DashboardAdminComponent {}
